import React, {useState} from 'react'
import { Link } from "react-router-dom";
import { Rating } from 'react-simple-star-rating'
import image1 from '../../../images/avatar/1.jpg'
import './Testimonials.css'

const Testimonials = () => {

    const [rating, setRating] = useState(0) 

    const handleRating = (rate: number) => {
      setRating(rate)
      // other logic
    }

    const decor = {
        textDecoration: 'none'
      }

  return (
    <div className='testy-container'>
        <div className="testy-wrapper">
          <div className="testyy">
            <img className='testy-img' src={image1} alt="image1" />
            <div className="testy-name">
                <p>ANTONY MOORE</p>
                <div className="testy-rating">
                  <Rating className='testy-rating' size={15} onClick={handleRating} ratingValue={rating} /* Available Props */ />
                </div>
            </div>
          </div>
          <p className='testy-text'>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Optio commodi laborum quam id aut nostrum, provident nihil fugit esse iste!</p>
          <div className="user">                   
                 <Link style={decor} to="/" className='views'><li >Via Twitter</li></Link>              
          </div>
        </div>
        <div className="testy-wrapper">
          <div className="testyy">
            <img className='testy-img' src={image1} alt="image1" />
            <div className="testy-name">
                <p>ANTONY MOORE</p>
                <div className="testy-rating">
                  <Rating className='testy-rating' size={15} onClick={handleRating} ratingValue={rating} /* Available Props */ />
                </div>
            </div>
          </div>
          <p className='testy-text'>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Optio commodi laborum quam id aut nostrum, provident nihil fugit esse iste!</p>
          <div className="user">                   
                 <Link style={decor} to="/" className='views'><li >Via Twitter</li></Link>              
            </div>
        </div>
        <div className="testy-wrapper">
          <div className="testyy">
            <img className='testy-img' src={image1} alt="image1" />
            <div className="testy-name">
                <p>ANTONY MOORE</p>
                <div className="testy-rating">
                  <Rating className='testy-rating' size={15} onClick={handleRating} ratingValue={rating} /* Available Props */ />
                </div>
            </div>
          </div>
          <p className='testy-text'>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Optio commodi laborum quam id aut nostrum, provident nihil fugit esse iste!</p>
          <div className="user">                   
                 <Link style={decor} to="/" className='views'><li >Via Twitter</li></Link>              
            </div>
        </div>
    </div>
  )
}

export default Testimonials